import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@material-ui/core";
import { DownloadIcon } from "App/Assets";
import {
  DatatablesFooterServerSide,
  IconButtonDatatable,
  Loading,
  //   ModalDeleteConfirm,
} from "App/Component/ui";
import TableHeader from "App/Component/ui/datatable/TableHeader";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { BASE_URL_4, instance4, STYLE_DEFAULT_MASTER } from "App/constants";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import {
  defaultDateDisplay,
  defaultToastError,
  //   defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import fileDownload from "js-file-download";
import { useEffect, useState } from "react";
import FormFilter from "./FormFilter";
import {
  //   deleteTransferAssetById,
  getByFilterTFA,
  headCells,
  RESET_STATE_FORM_FILTER,
} from "./helpers";

export default function DaftarKeseluruhanTransfer({
  changeTitle,
  changeParentData,
  changeMenu,
  handleClickMenu,
}) {
  const classes = STYLE_DEFAULT_MASTER();
  const [rows, setRows] = useState([]);
  //   const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  //   const [deleteRow, setDeleteRow] = useState([]);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async (
    pages = formFilter.halaman,
    limit = formFilter.jumlah
  ) => {
    setLoading(true);

    const res = await getByFilterTFA(formFilter, pages, limit);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  //   async function deleteList() {
  //     const res = await deleteTransferAssetById(deleteRow);
  //     if (res.state) {
  //       defaultToastSuccess(res.message);
  //       setNewData();
  //     } else {
  //       defaultToastError(res.message);
  //     }
  //     setShowModalDeleteConfirm(false);
  //   }

  //   function clickDelete(row) {
  //     setDeleteRow(row?.id);
  //     setShowModalDeleteConfirm(!showModalDeleteConfirm);
  //   }

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  const downloadPDF = async (id, fileName) => {
    setLoading(true);
    try {
      const api = await instance4.get(
        `${BASE_URL_4}/wmsAsset/transfer/download-pdf/${id}`,
        {
          responseType: "blob",
        }
      );
      const name = fileName + ".pdf";
      fileDownload(api.data, name);
    } catch (error) {
      return {
        state: false,
        message: error?.response?.data?.message,
      };
    }
    setLoading(false);
  };

  return (
    <>
      {/* {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )} */}
      <div className='mt-2'>
        <Paper
          className={classes.paper}
          style={{
            padding: "1rem 1.5rem",
          }}>
          <p className='fw-600 mb-1 mt-1'>DAFTAR KESELURUHAN TRANSFER ASSET</p>
          <div className='mt-1'>
            <FormFilter
              formFilter={formFilter}
              setFormFilter={setFormFilter}
              setNewData={setNewData}
            />
          </div>
        </Paper>
      </div>
      <div className='mt-1'>
        <Paper
          className={classes.paper}
          style={{
            padding: "1rem 1.5rem",
          }}>
          <Loading show={loading} />
          <TableContainer className='custom-scrollbar'>
            <Table
              className={classes.table}
              aria-labelledby='tableTitle'
              size={"medium"}
              aria-label='enhanced table'>
              <TableHeader
                classes={classes}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={length}
                headCells={headCells}
              />
              <TableBody>
                {stableSort(rows, getComparator(order, orderBy)).map(
                  (row, index) => {
                    return (
                      <TableRow
                        hover
                        tabIndex={-1}
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "transparent" : "#fff",
                        }}>
                        <TableCell
                          component='th'
                          scope='row'
                          padding='none'
                          align='center'>
                          {index + 1}
                        </TableCell>

                        <TableCell
                          component='th'
                          scope='row'
                          padding='none'
                          align='left'>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "7px",
                            }}>
                            <IconButtonDatatable
                              onClick={() => downloadPDF(row.id, row.code)}>
                              <DownloadIcon />
                            </IconButtonDatatable>
                          </div>
                        </TableCell>
                        <TableCell align='left'>{row?.id}</TableCell>
                        <TableCell align='left'>{row?.nama_asset}</TableCell>
                        <TableCell align='left'>{row?.fixasset_Id}</TableCell>
                        <TableCell align='left'>{row?.code}</TableCell>
                        <TableCell align='left'>
                          {defaultDateDisplay(row?.date, false)}
                        </TableCell>
                        <TableCell align='left'>
                          {isNull(row?.petugas) ? "-" : row?.petugas}
                        </TableCell>
                        <TableCell align='left'>
                          {isNull(row?.penerima) ? "-" : row?.penerima}
                        </TableCell>
                        <TableCell align='left'>{row?.gudang_sumber}</TableCell>
                        <TableCell align='left'>{row?.gudang_tujuan}</TableCell>
                        <TableCell align='left'>
                          {isNull(row?.remark) ? "-" : row?.remark}
                        </TableCell>
                        <TableCell align='left'>
                          {defaultDateDisplay(row?.createdAt)}
                        </TableCell>
                        <TableCell align='left'>{row?.createdBy}</TableCell>
                      </TableRow>
                    );
                  }
                )}
                {rows.length === 0 && (
                  <TableRow>
                    <TableCell align='center' colSpan={headCells.length}>
                      Tidak ada data
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>
    </>
  );
}
